import { tv } from 'tailwind-variants';

export const entityActionStyle = tv({
  base: 'h-10 rounded-lg bg-green-100 flex items-center justify-center hover:bg-green-200 disabled:opacity-50',
  variants: {
    variant: {
      icon: 'w-10 shrink-0',
      labeled: 'flex-1 min-w-0 gap-2 px-4 py-2 text-base font-semibold text-green-500',
    },
  },
  defaultVariants: {
    variant: 'icon',
  },
});

export const entityActionsRowStyle = tv({
  slots: {
    desktop: 'hidden',
    compact: 'flex items-center gap-2',
  },
  variants: {
    scheduleActionOnDesktop: {
      'none': {
        desktop: 'items-center gap-2 xl:grid xl:grid-cols-2',
        compact: 'xl:hidden',
      },
      'always': {
        desktop: 'items-start gap-3 lg:grid lg:grid-cols-3',
        compact: 'lg:hidden',
      },
      'until-xl': {
        desktop: 'items-start gap-3 lg:grid lg:grid-cols-3 xl:grid-cols-2',
        compact: 'lg:hidden',
      },
    },
  },
  defaultVariants: {
    scheduleActionOnDesktop: 'none',
  },
});
